import { createContext, useContext, useState, useEffect } from 'react'

export const THEMES = {
  parchment: {
    id: 'parchment',
    label: '羊皮紙',
    nav:      '#5a4a2a',
    navText:  '#f5f0e0',
    bg:       '#f5f1e8',
    paper:    '#fdfbf5',
    paper2:   '#f9f5ea',
    ink:      '#2a2620',
    inkSoft:  '#5c554a',
    inkMuted: '#8a8275',
    line:     '#d9d2c0',
    lineSoft: '#e8e2d2',
    greenDark: '#3a5a3a',
    green:    '#5b7d4f',
    greenPale: '#d8e2cc',
    carrot:   '#d97742',
    carrotSoft: '#f0c39b',
    tomato:   '#c0463a',
    gold:     '#c9963f',
    accent:   '#5a4a2a',
  },
  indigo: {
    id: 'indigo',
    label: 'インディゴ',
    nav:      '#4338ca',
    navText:  '#ffffff',
    bg:       '#f1f5f9',
    paper:    '#ffffff',
    paper2:   '#f8fafc',
    ink:      '#0f172a',
    inkSoft:  '#334155',
    inkMuted: '#64748b',
    line:     '#e2e8f0',
    lineSoft: '#f1f5f9',
    greenDark: '#15803d',
    green:    '#22c55e',
    greenPale: '#dcfce7',
    carrot:   '#f97316',
    carrotSoft: '#fed7aa',
    tomato:   '#dc2626',
    gold:     '#d97706',
    accent:   '#4338ca',
  },
  forest: {
    id: 'forest',
    label: '森林',
    nav:      '#1a3a2a',
    navText:  '#e8f0e4',
    bg:       '#eef3ea',
    paper:    '#f8fbf6',
    paper2:   '#eef3ea',
    ink:      '#1a2e1a',
    inkSoft:  '#3a5a3a',
    inkMuted: '#6a8a6a',
    line:     '#c0d4b8',
    lineSoft: '#d8e8d0',
    greenDark: '#2d5a2d',
    green:    '#4a8040',
    greenPale: '#c8e0c0',
    carrot:   '#c87040',
    carrotSoft: '#e8c098',
    tomato:   '#a83830',
    gold:     '#b08030',
    accent:   '#2d5a2d',
  },
}

const STORAGE_KEY = 'spe_theme'

const ThemeContext = createContext(null)

export function ThemeProvider({ children }) {
  const [themeId, setThemeId] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(STORAGE_KEY) || 'parchment'
    }
    return 'parchment'
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, themeId)
    }
  }, [themeId])

  const theme = THEMES[themeId] || THEMES.parchment

  return (
    <ThemeContext.Provider value={{ theme, themeId, setThemeId }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const ctx = useContext(ThemeContext)
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider')
  return ctx
}
